import { auth } from '../../utils/auth';
import { FormattedMessage } from 'react-intl';
import { isAuthenticated, isAuthInitialized } from '../../utils/authUtils';
import { redirectToDashboard, redirectToSignUp } from '../../utils/router';
import { RootState, useAppSelector } from '../../redux/store';
import {
  CreateAccountButton,
  Root,
  SkeletonBar,
  SkeletonContainer,
  SignInLink,
  HaveAnAccount,
} from './DoMoreWithRentalAccountActionsStyle';

function DoMoreWithRentalAccountActions() {
  const authState = useAppSelector((state: RootState) => state.auth);

  const handleSignin = () => {
    auth.login();
  };

  const handleSignup = () => {
    redirectToSignUp(location.pathname);
  };

  return isAuthInitialized(authState.loginStatus) ? (
    <Root>
      {isAuthenticated(authState.loginStatus) ? (
        <CreateAccountButton onClick={redirectToDashboard}>
          <FormattedMessage id={'doMoreWithRentalAccount.myAccount'} />
        </CreateAccountButton>
      ) : (
        <>
          <CreateAccountButton onClick={handleSignup}>
            <FormattedMessage id={'doMoreWithRentalAccount.createAccount'} />
          </CreateAccountButton>
          <HaveAnAccount>
            <FormattedMessage id={'doMoreWithRentalAccount.alreadyHaveAnAccount'} />
            <SignInLink as={'span'} onClick={handleSignin}>
              <FormattedMessage id={'doMoreWithRentalAccount.signIn'} />
            </SignInLink>
          </HaveAnAccount>
        </>
      )}
    </Root>
  ) : (
    <SkeletonContainer>
      <SkeletonBar animation='wave' />
      <SkeletonBar animation='wave' />
    </SkeletonContainer>
  );
}

export default DoMoreWithRentalAccountActions;
